<template>
  <div class="pill" :style="{ backgroundColor: backgroundColor, color: color }">
    <slot></slot>
    <button v-if="deletable" class="pill__delete" @click="emit('delete')">
      <span class="visually-hidden">{{ t('global.remove') }}</span>
      &#x2715;
    </button>
  </div>
</template>

<script>
  import { defineComponent } from 'vue'
  import { useStrings } from '@/composables/useStrings.ts'

  export default defineComponent({
    props: {
      deletable: {
        type: Boolean,
        default: true,
      },
      backgroundColor: {
        type: String,
        default: '#dddddd',
      },
      color: {
        type: String,
        default: '#fff',
      },
    },
    setup(props, { emit }) {
      const { t } = useStrings()
      return { emit, t }
    },
  })
</script>

<style lang="scss" scoped>
  $pill-height: 2rem;

  .pill {
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: $grey-light;
    border-radius: math.div($pill-height, 2);
    padding: 0.3em 0.8em 0.35em 0.8em;
    line-height: 1;
  }

  .pill__delete {
    padding: 0;
    margin-left: $spacer05;
    appearance: none;
    border: 0;
    background: none;
    font-size: 0.8em;
    color: currentColor;
    line-height: 1;
  }
</style>
